(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.custom-accordion-wrapper').forEach(wrapper => {
  const btn = wrapper.querySelector('.accordion-btn');
  const overlay = wrapper.querySelector('.accordion-overlay');
  const closeBtn = wrapper.querySelector('.accordion-close');

  // Open accordion
  btn.addEventListener('click', (e) => {
    e.stopPropagation();

    // Pehle sab ko close kar do aur icons hide kar do
    document.querySelectorAll('.custom-accordion-wrapper').forEach(w => {
      if(w !== wrapper){
        w.classList.remove('active');
      }
    });

    // Apne wrapper ko toggle karo
    wrapper.classList.toggle('active');
  });

  // Close when overlay clicked
  overlay.addEventListener('click', () => {
    wrapper.classList.remove('active');
  });

  // Close when cross clicked
  closeBtn.addEventListener('click', () => {
    wrapper.classList.remove('active');
  });

  // Close if clicked outside
  document.addEventListener('click', (e) => {
    if(wrapper.classList.contains('active') && !wrapper.contains(e.target)){
      wrapper.classList.remove('active');
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
